<script>
  import { onMount } from 'svelte';

  import Headline from './components/Headline.svelte';
  import HeaderLight from './HeaderLight/index.svelte';
  import Map from './Map/index.svelte';
  import CountryDetail from './components/CountryDetail/index.svelte';
  import Legend from './components/Legend.svelte';

  import { data, funfacts, mapTransform } from './stores';
  import { loadCsv, parseProductData, getMapTransform } from './utils';
  import { csvBasePath } from './config';

  onMount(async () => {
    const productData = await loadCsv(`${csvBasePath}koro-data.csv`);
    const funfactData = await loadCsv(`${csvBasePath}funfacts.csv`);

    data.set(parseProductData(productData));
    funfacts.set(funfactData);
  });

  let mapWidth = 0;

  $: mapHeight =
    mapWidth > 0 ? Math.min(mapWidth * 0.5, window.innerHeight / 2) : 0;

  const onResize = () => mapTransform.set(getMapTransform());
</script>

<style>
  .koromap,
  .koromap :global(.button) {
    margin: 0 auto;
    font-family: 'axiforma', Arial, sans-serif;
    font-weight: 700;
    color: #3a3a3a;
  }

  .koromap {
    max-width: 72.75rem;
    min-height: 400px;
  }

  footer :global(.km-headline) {
    display: none;
  }

  @media screen and (min-width: 800px) {
    .koromap > :global(.km-headline) {
      display: none;
    }
    footer {
      display: flex;
    }

    footer :global(.km-headline) {
      position: relative;
      top: -115px;
      display: block;
    }

    footer :global(.km-legend) {
      position: relative;
      top: -10px;
    }
  }
</style>

<svelte:window on:resize{onResize} />

<div bind:clientWidth={mapWidth} class="koromap">
  <Headline />
  <HeaderLight />
  <Map width={mapWidth} height={mapHeight} />
  <CountryDetail />
  <footer>
    <Headline />
    <Legend />
  </footer>
</div>
